import { Box, styled } from '@mui/material';

import { Button } from '»components/atoms/Button';

export const OtpContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isTighter',
})(({ margin, isTighter }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  margin,

  '& .MuiFormControl-root': {
    width: isTighter && '200px',
  },
}));

export const SendCodeButton = styled(Button)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textAlign: 'left',
  textTransform: 'none',
  textDecoration: 'underline',
  color: theme.palette.colors.onPrimaryBackground,
  padding: 0,
  margin: '8px 0',

  '&:hover': {
    color: `${theme.palette.colors.onPrimaryBackground} !important`,
    textDecoration: 'underline !important',
  },
  '&:disabled': {
    color: theme.palette.colors.off,
  },
  '& .MuiCircularProgress-root': {
    color: theme.palette.colors.onPrimaryBackground,
  },
}));
